import { render } from "./PageTitle.vue?vue&type=template&id=6d781264"
const script = {}

import "./PageTitle.vue?vue&type=style&index=0&id=6d781264&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__